import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import { ThemeProvider } from 'styled-components';

import { defineProj4Projections } from '../utils/proj4/projections';
import { LanguageProvider } from './components/language-provider/language-provider';
import { VersionMismatchToast } from './components/version-mismatch-toast/version-mismatch-toast';
import { Root } from './routes/root';
import { AuthStateProvider } from './state/auth-state';
import { IntercomProviderWithContext } from './state/intercom-state';
import { ThemeStateProvider } from './state/theme-state';
import { ToasterState } from './state/toaster-state';
import { UserStateAdapterBridge } from './state/user-state/adapter/user-state-adapter-bridge';
import { UserStateProvider } from './state/user-state/user-state';
import { defaultTheme } from './themes/default/styled-component/theme';
import { ThemeManager } from './themes/theme-manager';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      networkMode: 'always',
    },
  },
});

export default function App() {
  React.useEffect(() => {
    defineProj4Projections();
    ThemeManager.instance;
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={defaultTheme}>
        <ThemeStateProvider>
          <AuthStateProvider>
            <UserStateProvider>
              <UserStateAdapterBridge />
              <IntercomProviderWithContext>
                <LanguageProvider>
                  <ToasterState>
                    <VersionMismatchToast />
                    <Root />
                  </ToasterState>
                </LanguageProvider>
              </IntercomProviderWithContext>
            </UserStateProvider>
          </AuthStateProvider>
        </ThemeStateProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
